import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { InstrumentApiService } from './instrument.service';
import {
  loadInstrumentList,
  loadInstrumentListSuccess,
  loadInstrumentListFailure,
} from './instrument.actions';

@Injectable()
export class InstrumentEffects {
  private actions$ = inject(Actions);
  private instrumentService = inject(InstrumentApiService);

  loadInstrumentList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInstrumentList),
      mergeMap(() =>
        this.instrumentService.getInstrumentList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadInstrumentListFailure({ error: response.message });
            }
            return loadInstrumentListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadInstrumentListFailure({ error })))
        )
      )
    )
  );
}
